/**
 * URLs do ecossistema IBCGP — única fonte para CTAs e links externos da home.
 */
export default {
  /** API pública de cursos (landing / listagens) */
  apiCursos: 'https://api.cursos.ibcgp.org.br',
  /** Plataforma administrativa multifinalitária (gestão pública) */
  plataformaGestao: 'https://plataforma.ibcgp.org.br',
  /** Portal de concursos e processos seletivos */
  concursosPublico: 'https://concursos.ibcgp.org.br',
  /** Landing / vitrine de cursos (ajustar se o domínio público for outro) */
  cursosLanding: 'https://nucleodegestaoassomasul.ibcgp.org.br',
  /** Área logada da plataforma de cursos (LMS) */
  cursosPlataformaLogin:
    'https://nucleodegestaoassomasul.ibcgp.org.br/plataforma/#/login',
  /** Contato com assunto pré-preenchível (mensurável) */
  contatoAfiliacao: '/contato?assunto=afiliacao',
  contato: '/contato',
  contatoDemonstracao: '/contato?assunto=demonstracao',
  /** Instagram institucional */
  instagram: 'https://www.instagram.com/ibcgp/',
  /**
   * URL do iframe de embed. O embed de perfil (…/usuario/embed) pode ser bloqueado pelo Instagram;
   * em caso de tela em branco, troque por um embed de post: https://www.instagram.com/p/CODIGO_DO_POST/embed
   */
  instagramEmbedIframe: 'https://www.instagram.com/ibcgp/embed',
}
